import { Navigate } from "react-router";
import { useBranch } from "../hooks/useBranch";
import { Spinner } from "../components/Spinner";
import auth from "../utils/auth";

const getRouteContextFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const leaseId = Number(params.get("leaseId"));
  const propertyId = Number(params.get("propertyId"));

  return {
    leaseId: Number.isFinite(leaseId) && leaseId > 0 ? leaseId : null,
    propertyId: Number.isFinite(propertyId) && propertyId > 0 ? propertyId : null,
  };
};

export default function RedirectRouterPage() {
  if (!auth.isAuthenticated()) {
    // Store the current URL so Branch can resolve after login
    localStorage.setItem("branch_redirect_url", window.location.href);
    return <Navigate to="/login" replace />;
  }

  return <RedirectRouterAuthenticated />;
}

function RedirectRouterAuthenticated() {
  const { leaseId, propertyId } = getRouteContextFromUrl();
  const { route, error, isLoading: isBranchLoading } = useBranch(leaseId, propertyId);
  
  if (error) {
    return (
      <div className="h-screen flex flex-col justify-center items-center gap-4">
        <p className="text-lg font-medium text-gray-900">
          We are sorry, there was an error. Please try again.
        </p>
        <a href="/" className="text-blue-500 underline">
          Go to home
        </a>
      </div>
    );
  }

  if (isBranchLoading || !route) {
    return (
      <div className="h-screen flex justify-center items-center">
        <Spinner color="livly" size="xl" />
      </div>
    );
  }

  return <Navigate to={route} replace />;
}
